import React, { useState } from "react";
import axios from "axios";
import { Button, Input, Form, Card, message, Spin, Typography } from "antd";
import { getServiceUrl } from "../../util/util";
import { useStateValue } from "../stateProvider/stateProvider";

const { Title, Text, Link } = Typography;

const SDWorxTriggerSettings = () => {
  const [{ token }, dispatch] = useStateValue();
  const [quotationNumber, setQuotationNumber] = useState("");
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSearch = async () => {
    if (!quotationNumber) {
      message.error("Please enter a quotation number");
      return;
    }

    setLoading(true);
    setResponse(null);
    try {
      const url = await getServiceUrl("sdworxManualQuotationHandler", token);
      const { data } = await axios.post(url, {
        quotationNumber,
      });

      setResponse(data);
    } catch (err) {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setResponse({
          ...err.response.data,
          error: true,
        });
      } else {
        message.error("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 40, display: "flex", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: 500 }}>
        {/* Input Card */}
        <Card
          title={<Title level={4}>Create Deal from SDWorx Quotation</Title>}
          bordered
          style={{ borderRadius: 10, boxShadow: "0 4px 16px rgba(0,0,0,0.1)" }}
        >
          <Spin spinning={loading} tip="Processing..." size="large">
            <Form layout="vertical">
              <Form.Item label="Quotation Number">
                <Input
                  size="large"
                  placeholder="Enter quotation number"
                  value={quotationNumber}
                  onChange={(e) => setQuotationNumber(e.target.value)}
                  style={{ borderRadius: 6 }}
                  disabled={loading}
                />
              </Form.Item>

              <Button
                type="primary"
                size="large"
                onClick={onSearch}
                style={{ width: "100%", borderRadius: 6, fontWeight: 500 }}
                disabled={loading || process.env.REACT_APP_ENV === "staging"}
              >
                Create Deal
              </Button>
            </Form>
          </Spin>
        </Card>

        {/* Response UI */}
        {response && (
          <Card
            title="Response"
            style={{
              marginTop: 24,
              borderRadius: 10,
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            }}
          >
            <Spin spinning={loading}>
              <div style={{ padding: "10px 0" }}>
                {/* Main Message */}
                <Text
                  strong
                  style={{ fontSize: 16, display: "block", marginBottom: 12 }}
                >
                  {response.message}
                </Text>

                {/* Deal URL */}
                {response.dealUrl && (
                  <div style={{ marginBottom: 20 }}>
                    <Text type="secondary">Deal URL:</Text>
                    <br />
                    <a
                      href={response.dealUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: 15,
                        fontWeight: 500,
                        color: "#1677ff",
                      }}
                    >
                      {response.dealUrl}
                    </a>
                  </div>
                )}
              </div>
            </Spin>
          </Card>
        )}
      </div>
    </div>
  );
};

export default SDWorxTriggerSettings;
